export interface PartnersImagesNewInterface {
  path: String;
  alt: String;
}

export const partnersImages: Array<PartnersImagesNewInterface> = [
  { path: './assets/images/partners/kettler.png', alt: 'Kettler' },
  { path: './assets/images/partners/bhfitness.png', alt: 'BH Fitness' },
  { path: './assets/images/partners/domyos.png', alt: 'Domyos' },
  { path: './assets/images/partners/SportsTech.png', alt: 'SportsTech' },
  { path: './assets/images/partners/Technogym.png', alt: 'TechnoGym' },
  { path: './assets/images/partners/Elite.png', alt: 'Elite' },
  { path: './assets/images/partners/reebok.png', alt: 'Rebook' },
  { path: './assets/images/partners/Wahoo.png', alt: 'Wahoo' },
  { path: './assets/images/partners/Concept2.png', alt: 'Concept 2' },
  { path: './assets/images/partners/saris.png', alt: 'Saris' },
  { path: './assets/images/partners/FlowFitness.png', alt: 'Flow Fitness' },
  { path: './assets/images/partners/bluefin-fitness.png', alt: 'BlueFin' },
  { path: './assets/images/partners/Tacx.png', alt: 'Tacx' },
  { path: './assets/images/partners/toorx.png', alt: 'Toorx' },
  { path: './assets/images/partners/zycle.png', alt: 'Zycle' },
  { path: './assets/images/partners/trinfit.png', alt: 'TrinFit' },
  { path: './assets/images/partners/behumax.png', alt: 'Behumax' },
  { path: './assets/images/partners/alinco.png', alt: 'Alinco' },
  { path: './assets/images/partners/virtufit.png', alt: 'Virtufit' }
];

export const partnersCarouselImages = [
  { name: 'abilica', weight: 1},
  { name: 'adidas', weight: 2},
  { name: 'alinco', weight: 1},
  { name: 'aquarowing', weight: 1},
  { name: 'artgo', weight: 1},
  { name: 'asviva', weight: 1},
  { name: 'behumax', weight: 1},
  { name: 'beter-sport', weight: 1},
  { name: 'BHFitness', weight: 2},
  { name: 'biorower', weight: 1},
  { name: 'bluefin-fitness', weight: 1},
  { name: 'BodyBike', weight: 1},
  { name: 'bodycraft', weight: 2},
  { name: 'BodyFlex', weight: 1},
  { name: 'bodymax', weight: 1},
  { name: 'bodyswiss', weight: 1},
  { name: 'bodytone', weight: 2},
  { name: 'bowflex', weight: 1},
  { name: 'brother', weight: 1},
  { name: 'capital-sports', weight: 2},
  { name: 'cardiofitness', weight: 1},
  { name: 'cardiostrong', weight: 2},
  { name: 'CareFitness', weight: 2},
  { name: 'cascade', weight: 1},
  { name: 'christopeit-sport', weight: 2},
  { name: 'Ciclotte', weight: 1},
  { name: 'Concept2', weight: 2},
  { name: 'conlin', weight: 1},
  { name: 'crivit', weight: 1},
  { name: 'dansprint', weight: 1},
  { name: 'd-c-athletics', weight: 1},
  { name: 'diadora', weight: 1},
  { name: 'DKN', weight: 1},
  { name: 'Domyos', weight: 2},
  { name: 'Elite', weight: 2},
  { name: 'fassi', weight: 1},
  { name: 'finnlo', weight: 2},
  { name: 'first-degree-fitness-fluid-exercice', weight: 2},
  { name: 'first-degree-fitness-fluid-rower', weight: 1},
  { name: 'fitbike', weight: 1},
  { name: 'fitengine', weight: 1},
  { name: 'fitifito', weight: 1},
  { name: 'fitnord', weight: 1},
  { name: 'fitshow', weight: 1},
  { name: 'FlowFitness', weight: 1},
  { name: 'focus-fitness', weight: 1},
  { name: 'force-usa', weight: 1},
  { name: 'genis-fitness', weight: 1},
  { name: 'giant', weight: 1},
  { name: 'gowell-fitness', weight: 1},
  { name: 'gymconnect', weight: 1},
  { name: 'Gymost', weight: 1},
  { name: 'gymstick', weight: 1},
  { name: 'Hammer', weight: 2},
  { name: 'hci-fitness', weight: 1},
  { name: 'heubozen', weight: 2},
  { name: 'hop-sport', weight: 1},
  { name: 'horizon-fitness', weight: 2},
  { name: 'jasport', weight: 1},
  { name: 'JetBlack', weight: 2},
  { name: 'jk-fitness', weight: 2},
  { name: 'jll-fitness', weight: 2},
  { name: 'johnson-fitness', weight: 2},
  { name: 'joroto', weight: 1},
  { name: 'jtx-fitness', weight: 1},
  { name: 'kayakpro', weight: 2},
  { name: 'keiser', weight: 1},
  { name: 'Kettler', weight: 2},
  { name: 'Kinetic', weight: 1},
  { name: 'klarfit', weight: 1},
  { name: 'LifeFitness', weight: 2},
  { name: 'lifepro-fitness', weight: 1},
  { name: 'lifespan-fitness', weight: 1},
  { name: 'lycan-fitness-equipment', weight: 1},
  { name: 'magene-technology-co', weight: 1},
  { name: 'Marcy', weight: 1},
  { name: 'masterfit', weight: 1},
  { name: 'matrix', weight: 2},
  { name: 'maxxus', weight: 1},
  { name: 'mcfitness', weight: 1},
  { name: 'mekbelt', weight: 1},
  { name: 'Minoura', weight: 1},
  { name: 'miweba-sports', weight: 1},
  { name: 'moovyoo', weight: 2},
  { name: 'neezee', weight: 1},
  { name: 'niceday', weight: 1},
  { name: 'noble-pro', weight: 1},
  { name: 'nohrd', weight: 1},
  { name: 'npe', weight: 1},
  { name: 'orbit-fitness-equipment', weight: 1},
  { name: 'oreka-training', weight: 1},
  { name: 'orion-fitness', weight: 1},
  { name: 'ovicx', weight: 1},
  { name: 'peak-fitness', weight: 1},
  { name: 'powerland', weight: 1},
  { name: 'powerplus', weight: 1},
  { name: 'precor', weight: 1},
  { name: 'Pro-Form', weight: 1},
  { name: 'progressive', weight: 1},
  { name: 'reebok', weight: 2},
  { name: 'renpho', weight: 1},
  { name: 'Revbox', weight: 1},
  { name: 'salter', weight: 1},
  { name: 'saris', weight: 1},
  { name: 'SchwinnFitness', weight: 1},
  { name: 'senz-sports', weight: 1},
  { name: 'Skandika', weight: 2},
  { name: 'sole-fitness', weight: 1},
  { name: 'speedo-only-in-brazil', weight: 1},
  { name: 'spirit', weight: 2},
  { name: 'sportplus', weight: 1},
  { name: 'sportsart-1', weight: 1},
  { name: 'sportsmaster', weight: 2},
  { name: 'SportsTech', weight: 1},
  { name: 'stages-cycling', weight: 1},
  { name: 'stairmaster', weight: 1},
  { name: 'starke', weight: 1},
  { name: 'star-trac', weight: 2},
  { name: 'stil-fit', weight: 1},
  { name: 'Striale', weight: 1},
  { name: 'stryd', weight: 1},
  { name: 'synchronaction', weight: 1},
  { name: 'Tacx', weight: 2},
  { name: 'taurus', weight: 1},
  { name: 'techfit', weight: 1},
  { name: 'technogym', weight: 2},
  { name: 'tecnofit', weight: 1},
  { name: 'toorx', weight: 2},
  { name: 'topiom', weight: 1},
  { name: 'torneo', weight: 1},
  { name: 'treadtracker', weight: 1},
  { name: 'trinfit', weight: 1},
  { name: 'Tunturi', weight: 1},
  { name: 'tx-fitness', weight: 1},
  { name: 'uk-fitness', weight: 1},
  { name: 'upower', weight: 1},
  { name: 'van-rysel	', weight: 1},
  { name: 'virtufit', weight: 1},
  { name: 'vrai-fitness', weight: 1},
  { name: 'Wahoo', weight: 2},
  { name: 'waterrower', weight: 2},
  { name: 'Wattbike', weight: 1},
  { name: 'Weslo', weight: 1},
  { name: 'xebex', weight: 1},
  { name: 'xg-fitness', weight: 1},
  { name: 'xterra', weight: 1},
  { name: 'yesoul', weight: 2},
  { name: 'your-move', weight: 1},
  { name: 'zipro', weight: 1},
  { name: 'zycle', weight: 2}
]
